var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadge01Relay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H16C18.2091 0 20 1.79086 20 4V16C20 18.2091 18.2091 20 16 20H4C1.79086 20 0 18.2091 0 16V4Z",
    fill: "#F47F88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3168 11.575H5.91667V5.275H13.3168C13.8859 5.275 14.256 5.89107 14.0015 6.41468L13.1956 8.07282C13.0878 8.29452 13.0878 8.55548 13.1956 8.77718L14.0015 10.4353C14.256 10.9589 13.8859 11.575 13.3168 11.575Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.91667 4.3125C6.15829 4.3125 6.35417 4.50838 6.35417 4.75V4.8375H13.3168C14.2289 4.8375 14.782 5.80982 14.395 6.60593L13.5891 8.26407C13.54 8.36503 13.54 8.48497 13.5891 8.58593L14.395 10.2441C14.782 11.0402 14.2289 12.0125 13.3168 12.0125H6.35417V14.8125H7.08333C7.32496 14.8125 7.52083 15.0084 7.52083 15.25C7.52083 15.4916 7.32496 15.6875 7.08333 15.6875H4.75C4.50838 15.6875 4.3125 15.4916 4.3125 15.25C4.3125 15.0084 4.50838 14.8125 4.75 14.8125H5.47917V4.75C5.47917 4.50838 5.67504 4.3125 5.91667 4.3125ZM6.35417 11.1375H13.3168C13.5429 11.1375 13.7301 10.8777 13.608 10.6266L12.8021 8.96843C12.6357 8.62598 12.6357 8.22402 12.8021 7.88157L13.608 6.22343C13.7301 5.97232 13.5429 5.7125 13.3168 5.7125H6.35417V11.1375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge01Relay);
export default __webpack_public_path__ + "static/media/badge_01_relay.da76a64771860992df80de7a8ee67685.svg";
export { ForwardRef as ReactComponent };